<template>
  <modal id="tooltip" v-cloak>
    <div slot="title">
      <h4>Welkom, {{ currentUser.lastName }}</h4>
    </div>
    <div slot="body">
      <p>Welkom bij de Timesheetapplicatie van Pulse. Dit is de eerste keer dat je inlogt op de app.
        Wanneer je een dag wil selecteren op je telefoon, moet je lang duwen op de dag.
        Hierna kan je kiezen tussen de shiften die tot je beschikking staan. De rode dagen zijn feestdagen.
      </p>
    </div>
  </modal>
</template>
<script>

export default {
  name: "tooltipModal",
  props: ['currentUser'],
};

</script>

<style scoped>

</style>